import { render } from "./app-form-customer.vue?vue&type=template&id=4acd18bb&scoped=true"
import script from "./app-form-customer.vue?vue&type=script&lang=js"
export * from "./app-form-customer.vue?vue&type=script&lang=js"

import "./app-form-customer.vue?vue&type=style&index=0&id=4acd18bb&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4acd18bb"],['__file',"src/views/components/form/reference/app-form-customer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4acd18bb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4acd18bb', __exports__)) {
    console.log('reload')
    api.reload('4acd18bb', __exports__)
  }
  
  module.hot.accept("./app-form-customer.vue?vue&type=template&id=4acd18bb&scoped=true", () => {
    console.log('re-render')
    api.rerender('4acd18bb', render)
  })

}


export default __exports__